import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Col, Row, Form, Modal } from 'react-bootstrap'
import { ContactButton, InputWithIcon, NextBackButton, SelectionDropdown } from '../../../ui/CustomElements'
import { Box, InnerHeading, LabelStyled, LazyImage, SpanStyled, TextStyled } from '../../../ui/Elements'
import { ArrowRight, BackArrow, BackArrowActive, NextArrow, SuccessLogo } from '../../../ui/AllImages'
import axios from 'axios'
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next'
import MapSearchSelect from '../../map/mapInput'
import { FloorList, NeighbourList } from '../../projectData/Data'
import CustomRadioButton, { RadioWrapper } from '../../../ui/CustomRadio'
import ContactApi from '../../../services/api/contactApi'
import ValidationErrorText from '../../inputFields/ValidationErrorText'
import ValidatedInput from '../../inputFields/ValidatedInput'
const StepTwo = ({ nextStep, prevStep, formData, setFormData }) => {
    const { register, handleSubmit, setValue, reset, watch, formState: { errors } } = useForm({
        defaultValues: {
            formData,
            pick_elevator_availability: "1" ,
        }
    });
    const { t, i18n: { language } } = useTranslation();
    const [isLocationValid, setIsLocationValid] = useState(true); // ✅ Track location validation
    const [NeighbourList, setNeighborhood] = useState([]);
    const [floorOptions, setFloorOptions] = useState([]);
    const selectedOption = watch("pick_elevator_availability");
    const fetchNeighborOptions = async () => {
        try {
            const response = await ContactApi.neighbourhoods();
            if (response?.data) {
                reset({
                    pick_neighbourhood_id: response?.data?.id || "",
                });
                const mappedNeighborOptions = response.data.map(
                    (neighbor) => ({
                        label: `${language === "ar" ? neighbor.name_ar : neighbor.name}`,
                        value: neighbor.id,
                    }));
                setNeighborhood(mappedNeighborOptions);
            }
        } catch (error) { }
    };
    const fetchFloorOptions = async () => {
        try {
            const response = await ContactApi.floors();
            if (response?.data) {
                reset({
                    pick_floor_id: response?.data?.id || "",
                });
                const mappedFloorOptions = response.data.map(
                    (floor) => ({
                        label: `${language === "ar" ? floor.name_ar : floor.name}`,
                        value: floor.id, // Send this ID in the request
                    }));
                setFloorOptions(mappedFloorOptions);
            }
        } catch (error) { }
    };
    useEffect(() => {
        fetchNeighborOptions([]);
        fetchFloorOptions({});
    }, [setNeighborhood, setFloorOptions, language]);
    const onSubmit = (data) => {
        if (!isLocationValid) {
            alert("Riyadh before proceeding.");
            return;
        }
        setFormData((prevData) => ({ ...prevData, ...data }));
        nextStep();
    };
    const handlePrevStep = (event) => {
        event.preventDefault(); 
        event.stopPropagation();
        prevStep();
    };
    useEffect(() => {
        if (NeighbourList.length > 0 && floorOptions.length > 0) {
            reset(formData);
        }
        if (formData?.pick_elevator_availability !== undefined) {
            reset({ 
                ...formData, 
                pick_elevator_availability: formData.pick_elevator_availability || "1"
            });
        } else {
            reset({ pick_elevator_availability: "1" });
        }
    }, [formData, reset, NeighbourList, floorOptions]); 
    
    return (
        <ContacFormWapper className='contactFormWrapper'>
            <Box>
                <Box className=''>
                    <Box className='d-flex flex-column align-items-start justify-content-start contactHeading'>
                        <InnerHeading className='' lh="1.2" size="20px" color="var(--themeColor)">{t('PickupLocationInformation')}</InnerHeading>
                    </Box>
                </Box>
                <Form  onSubmit={handleSubmit(onSubmit)}>
                    <Row className=''>
                        <Col lg={12} className='py-2 inputCol'>
                            <MapSearchSelect
                                label={t('PickupLocation')}
                                locationName="pick_location"
                                latName="pick_latitude"
                                lngName="pick_longitude"
                                registerMap={register}
                                setValue={setValue}
                                errors={errors}
                                defaultAddress={formData.pick_location}
                                setIsLocationValid={setIsLocationValid} // ✅ Pass validation state
                            />
                        </Col>
                        <Col lg={12} className='py-2 inputCol'>
                            <LabelStyled className='pt-2 pb-1'>{t('Neighborhood')}</LabelStyled>
                            <SelectionDropdown
                                placeholder={t("SelectNeighborhood")}
                                options={NeighbourList}
                                name="pick_neighbourhood_id"
                                value={watch("pick_neighbourhood_id") || formData?.pick_neighbourhood_id}
                                register={register}
                                errors={errors}
                                validationRules={{
                                    required: true,
                                }}
                            />
                            {errors.pick_neighbourhood_id?.type === "required" && (
                                <ValidationErrorText
                                    text={
                                        t(errors.pick_neighbourhood_id?.message) ||
                                        t("Pleaseselectone")
                                    }
                                />
                            )}
                        </Col>
                        <Col lg={12} className='py-2 inputCol'>
                            <LabelStyled className='pt-2 pb-1'>{t('Floor')}</LabelStyled>
                            <SelectionDropdown
                                name="pick_floor_id"
                                placeholder={t("SelectFloor")}
                                options={floorOptions}
                                value={watch("pick_floor_id") || formData?.pick_floor_id} 
                                register={register}
                                errors={errors}
                                validationRules={{
                                    required: true,
                                }}
                            />
                            {errors.pick_floor_id?.type === "required" && (
                                <ValidationErrorText
                                    text={
                                        t(errors.pick_floor_id?.message) ||
                                        t("Pleaseselectone")
                                    }
                                />
                            )}
                        </Col>
                        <Col md={12} className='py-2'>
                            <Box className="formEleContainer">
                                <LabelStyled className="pt-2 pb-1">
                                    {t('Isthereanelevator')}
                                </LabelStyled>
                                <Box className="d-flex gap-3 w-100">
                                    <RadioWrapper >
                                        <input
                                            className="radio-input"
                                            type="radio"
                                            name="pick_elevator_availability"
                                            value="1"
                                            {...register("pick_elevator_availability", { required: true })} 
                                            checked={watch("pick_elevator_availability") === "1" || formData?.pick_elevator_availability === "1"}
                                        />
                                        <span className="radio-text mx-2">{t("Yes")}</span>
                                    </RadioWrapper>
                                    <RadioWrapper>
                                        <input
                                            className="radio-input"
                                            type="radio"
                                            name="pick_elevator_availability"
                                            value="0"
                                            {...register("pick_elevator_availability", { required: true })}
                                            checked={watch("pick_elevator_availability") === "0" || formData?.pick_elevator_availability === "0"}
                                        />
                                        <span className="radio-text mx-2">{t("No")}</span>
                                    </RadioWrapper>
                                </Box>
                            </Box>
                        </Col>
                        <Box className='d-flex justify-content-between w-100 mt-5 btnNBWrap'>
                            <NextBackButton type="button" className="" content='end' backIcon={BackArrowActive} label={t('back')} bg="var(--white)" onClick={handlePrevStep} />
                            <Box className="nextTextContainer">
                                <Box className='progressTextContainer'>
                                    <SpanStyled className='txtEng'>
                                        2
                                    </SpanStyled>
                                    <SpanStyled className='ofProgTxt'>
                                        {t("Of")}
                                    </SpanStyled>
                                    <SpanStyled className='txtEng'>
                                        5
                                    </SpanStyled>
                                </Box>
                                <NextBackButton type="submit" className="" nextIcon={NextArrow} label={t('next')} />
                            </Box>
                        </Box>
                    </Row>
                </Form>
            </Box>
        </ContacFormWapper >
    )
}
const ContacFormWapper = styled.div`
`
export default StepTwo
